import { CSSProperties } from 'react';

export const container: CSSProperties = {
  width: '100%',
};

export const body: CSSProperties = {
  margin: 'auto',
  width: 360,
};
